import { EMITTER_CONSTANTS } from '@/shared/config';
import { CONFIG } from '@/entities/user';
import { getSearchParam, auth, emitter, storage, STORAGE_KEYS } from '@/shared/lib';
import queryString from 'query-string';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Handles the web-redirect landing route that hands a session over from the mobile app or the admin and sales portals. Sends Biocare portal logins to /inbox, records admin or sales user and facility ids on CONFIG before navigating to the requested URL, otherwise stores token, role and userId from the query string, navigates to the destination with isWebView and emits the token-changed event, and deep-links to biotres:// when parameters are missing.
 *
 * @returns Nothing.
 */
const useWebRedirect = () => {
  const location = useLocation();

  const navigate = useNavigate();

  // TODO: Need to encodeURI and  decodeURI with URL, waiting for mobile
  // Sample URL: http://localhost:3000/web-redirect?token=32f488fa44df308de0ca881940f6a8d711b5db67812b88f0c8d03675b872267e&to=/studies/create&userId=5f913c5e558a3971141cde0d&role=Clinic Technician
  // Sample URL 2:  http://localhost:3000/web-redirect?token=67559e6ac23bb70cde6cce65c5e4b661ef0443294a1d4e513c1fd61cd6b35ef5&to=/studies/63d73db58a1dd01e6f962459&userId=5f51f055beb0b48f548447cc&role=Clinic Technician

  useEffect(() => {
    if (auth.isLoginWithBiocarePortal()) {
      navigate('/inbox', { replace: true });
      return;
    }

    const values = queryString.parse(location.search);
    const { isLoginThroughAdmin, isLoginThroughSales, redirectUrl } = values;
    CONFIG.REDIRECT_ADMIN_OR_SALES_URL = window.location.href;
    if (isLoginThroughAdmin || isLoginThroughSales) {
      // *: Not logged in or logged in with Admin/Sales before (shall overwrite by the latest facility)
      const { userId, facilityId } = values;
      CONFIG.ADMIN_OR_SALES_USER_ID = userId as typeof CONFIG.ADMIN_OR_SALES_USER_ID;
      CONFIG.ADMIN_OR_SALES_FACILITY_ID = facilityId as typeof CONFIG.ADMIN_OR_SALES_FACILITY_ID;
      CONFIG.IS_LOGIN_THROUGH_ADMIN = isLoginThroughAdmin as typeof CONFIG.IS_LOGIN_THROUGH_ADMIN;
      CONFIG.IS_LOGIN_THROUGH_SALES = isLoginThroughSales as typeof CONFIG.IS_LOGIN_THROUGH_SALES;
      if (redirectUrl) {
        navigate(redirectUrl as any, { replace: true });
      } else {
        navigate('/inbox', { replace: true });
      }
    } else {
      const tokenURL = getSearchParam('token');
      const destinationPage = getSearchParam('to');
      const userId = getSearchParam('userId');
      const role = getSearchParam('role');
      if (tokenURL && destinationPage && userId && role) {
        storage.set(STORAGE_KEYS.accessToken, tokenURL);
        storage.set(STORAGE_KEYS.role, role);
        storage.set(STORAGE_KEYS.roles, [role]);
        storage.set(STORAGE_KEYS.userId, userId);
        const url = `${destinationPage}?isWebView=true`;
        navigate(url, { replace: true });
        emitter.emit(EMITTER_CONSTANTS.UPDATE_TOKEN_LOCAL_STORAGE, 'changed');
      } else {
        // For mobile handle
        window.location.href = 'biotres://end-createstudy/fail';
      }
    }
  }, [location]);
};

export { useWebRedirect };
